import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { modernHeaderSection, modernHeaderTitle } from '../../styles';

function PageHeader(props) {
  return (
    <Box className="bg-[linear-gradient(135deg,#1F305E_0%,#f5f5f5_50%,#1F305E_100%)] p-4 pl-9 text-white">
      <Box className="flex justify-between">
        <Typography className="!mb-0" style={modernHeaderTitle}>
          {props.title}
        </Typography>
        {props.children}
      </Box>
    </Box>
  );
}

PageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
};

export default PageHeader;
